import React, { Component } from 'react';
import cx from "classnames";
import get from 'lodash.get';
import { connect } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import FaCheckCircle from "react-icons/lib/fa/check-circle-o";
import FaExclamationTriangle from "react-icons/lib/fa/exclamation-triangle";
import DateRangePicker from '../../../Global/DateRangePicker';
import TeacherSelections from '../../../Reports/containers/TeacherSelections';
import { getUserData } from '../../../../services/API';
import {updateDistrictScreeningWindow, unassignAllDistrictAssignments, getDistrictWindow} from '../../../../services/assignment/districtAssignments.js'
import { getSchoolWindow, unassignSchoolAssignments, updateSchoolScreeningWindow } from '../../../../services/assignment/schoolAssignments';
import Loading from '../../../Global/Loading';
import { GetBrandedAppName } from '../../../../services/BrandingService';
import GradeSelector from './BenckmarkAssessment/DisableByGrade.js';
import { getAssessmentConfig, updateAssessmentConfigForDistrict, updateAssessmentConfigForSchool } from '../../../../services/amiraLicenseService.js';
import DisableByGradeBanner from './BenckmarkAssessment/DisableByGradeBanner.js';

const noActiveMessage = "No active benchmark assessment window";
const defaultWindowDisabledByGrade = [false, false, false, false, false, false, false];

class BenchmarkAssessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseData: null,
      isDistrictAssignmentAssigned: false,
      screeningWindow: {
        startDate: null,
        endDate: null,
      },
      loading: true,
      dateRangePickerVisible: false,
      screeningWindowChanged: false,
      selectedEntity: getUserData().userType == 'SCHOOL_ADMIN'
        ? 'school'
        : 'district',
    };

    this.fetchConfiguration = this.fetchConfiguration.bind(this);
    this.fetchSchoolWindow = this.fetchSchoolWindow.bind(this);
    this.onEntityChange = this.onEntityChange.bind(this);
    this.onDateRangeChange = this.onDateRangeChange.bind(this);
    this.setupWindow = this.setupWindow.bind(this);
    this.clearWindow = this.clearWindow.bind(this);
    this.clearDistrictWindow = this.clearDistrictWindow.bind(this);
    this.clearSchoolWindow = this.clearSchoolWindow.bind(this);
    this.saveWindow = this.saveWindow.bind(this);
    this.resetScreen = this.resetScreen.bind(this);
    this.onChangeGradesDisabled = this.onChangeGradesDisabled.bind(this);
  }

  componentDidMount() {
    this.fetchConfiguration();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.selectedSchool !== this.props.selectedSchool) {
      this.setState({ loading: true });
      this.fetchConfiguration();
    }
  }

  fetchConfiguration() {
    this.state.selectedEntity === 'school'
      ? this.fetchSchoolWindow()
      : this.fetchDistrictWindow();
  }

  async fetchSchoolWindow() {
    try {
      const selectedSchool = this.props.selectedSchool || getUserData().schools[0];
      const data = await getSchoolWindow(selectedSchool.id);
      const isDistrictAssignmentAssigned = data.length > 0 && data.every(({ entityType }) => entityType.toLowerCase() != 'school') && this.state.selectedEntity == 'school';
      let dateFrom =data[0] ? new Date(data[0].dateFrom) : null;
      let dateTo = data[0] ? new Date(data[0].dateTo) : null;
      const licenseData = await getAssessmentConfig(getUserData().district.id, selectedSchool.id);
      const windowDisabledByGrade = licenseData?.windowDisabledByGrade || defaultWindowDisabledByGrade;

      this.setState({
        loading: false,
        licenseData,
        windowDisabledByGrade,
        screeningWindow: {
          startDate: dateFrom,
          endDate: dateTo,
        },
        dateRangePickerVisible: false,
        screeningWindowChanged: false,
        hasScreeningWindowSchool: dateFrom && dateTo,
        welcomeMessage: this.getWelcomeMessage(dateFrom, dateTo, isDistrictAssignmentAssigned),
        isDistrictAssignmentAssigned,
      });
    } catch(error) {
      console.error('Error loading School Window', error);
      this.setState({ loading: false });
    }
  }

  async fetchDistrictWindow() {
    try {
      const data = await getDistrictWindow(getUserData().district.id);
      const isDistrictAssignmentAssigned = (data.length > 0 && data.every(({ entityType }) => entityType.toLowerCase() != 'school') && this.state.selectedEntity == 'school')
        || this.state.selectedEntity == 'district';
      let dateFrom =data[0] ? new Date(data[0].dateFrom) : null;
      let dateTo = data[0] ? new Date(data[0].dateTo) : null;

      // get assessment config for all schools in the district
      const districtWindowDisabledByGrade = await this.getDistrictAssessmentConfigs();
      const windowDisabledByGrade = districtWindowDisabledByGrade[0]?.disabled || defaultWindowDisabledByGrade;
      const hasSchoolWindowDisabledByGradeOverride = districtWindowDisabledByGrade?.some((obj) => obj.disabled?.some((grade, index) => grade !== windowDisabledByGrade[index]));

      this.setState({
        loading: false,
        windowDisabledByGrade,
        districtWindowDisabledByGrade,
        hasSchoolWindowDisabledByGradeOverride,
        hasScreeningWindowDistrict: dateFrom && dateTo,
        screeningWindow: {
          startDate: dateFrom,
          endDate: dateTo,
        },
        dateRangePickerVisible: false,
        screeningWindowChanged: false,
        welcomeMessage: this.getWelcomeMessage(dateFrom, dateTo, isDistrictAssignmentAssigned),
        isDistrictAssignmentAssigned,
      });
    } catch(error) {
      console.error('Error loading District Window', error);
      this.setState({ loading: false });
    }
  }

  async getDistrictAssessmentConfigs() {
    const userData = getUserData();
    const schools = userData.schools;
    let districtWindowDisabledByGrade = [];
  
    if (schools.length > 0) {
      const licenseDataPromises = schools.map(school =>
        getAssessmentConfig(userData.district.id, school.id).then(licenseData => ({
          schoolId: school.id,
          disabled: licenseData?.windowDisabledByGrade || defaultWindowDisabledByGrade
        }))
      );
  
      try {
        districtWindowDisabledByGrade = await Promise.all(licenseDataPromises);
      } catch (error) {
        console.error('Error fetching assessment config:', error);
      }
    }
  
    return districtWindowDisabledByGrade;
  }

  getWelcomeMessage(dateFrom, dateTo, isDistrictAssignmentAssigned){
    const userData = getUserData();
    const entityLabel = isDistrictAssignmentAssigned
      ? `${userData.district.label} district`
      : userData.userType == 'SCHOOL_ADMIN' ? userData.schools[0].label : this.props.selectedSchool.label;

    if(!dateFrom || !dateTo) return `There's no screening window set for ${entityLabel}`;

    return "There's a screening window set from " +
      (dateFrom.getMonth()+1)+'/'+ dateFrom.getDate()+'/'+dateFrom.getFullYear() +
      " to " +
      (dateTo.getMonth()+1)+'/'+ dateTo.getDate()+'/'+dateTo.getFullYear() +
      " for " + entityLabel + ".";
  }

  setupWindow() {
    let {screeningWindow} = this.state;
    if(!screeningWindow.startDate){
      screeningWindow = {
        startDate: new Date(), //default to today
        endDate: new Date(),
      }
    }
    this.setState({
      screeningWindow,
      screeningWindowChanged: false,
      dateRangePickerVisible: true,
    });
  }

  onDateRangeChange(item) {
    const { startDate, endDate } = item;

    this.setState({
      screeningWindow: {
        startDate: startDate,
        endDate: endDate,
      },
      screeningWindowChanged: true
    });
  }

  onEntityChange({ value }) {
    this.setState({
      loading: true,
      selectedEntity: value,
    }, this.fetchConfiguration);
  }

  onChangeGradesDisabled(gradesDisabled) {
    this.setState({
      windowDisabledByGrade: gradesDisabled,
    });
  }

  saveWindow(){
    if(!this.state.screeningWindowChanged) {
      return;
    }

    const { startDate, endDate } = this.state.screeningWindow;
    if (startDate && endDate) {
      const selectedSchool = this.props.selectedSchool || getUserData().schools[0];

      this.props.openModal(
        <div className='confirmation-modal'>
          <p>If you set an Assessment Window, {GetBrandedAppName()} will automatically assign every student an assessment as soon as the window is active.</p>
          <p>Students will not choose between practice and assessment – <strong>EVERY STUDENT WILL BE ASSESSED</strong> the first time they access
          {GetBrandedAppName()} in an active window.</p>
          <p>If you do not want this to happen, <strong>DO NOT SET A WINDOW</strong>. Instead, you can let teachers do an assignment for each class.</p>

          <GradeSelector onChangeGradesDisabled={this.onChangeGradesDisabled} hasSchoolWindowDisabledByGradeOverride={this.state.hasSchoolWindowDisabledByGradeOverride} selectedEntity={this.state.selectedEntity}/>
          <div className='confirmation-buttons'>
            <div
              className='primaryTeacherButton'
              style={{ lineHeight: '44px' }}
              onClick={() => {
                this.props.closeModal();
                this.fetchConfiguration();
              }}
            >
              CANCEL THE WINDOW
            </div>
            <div
              className='primaryTeacherButton screening'
              onClick={() => {
                this.props.closeModal();
                this.state.selectedEntity === 'school'
                  ? this.saveToSchool(startDate, endDate, selectedSchool.id)
                  : this.saveToDistrict(startDate, endDate);
              }}
            >
              PROCEED WITH AUTO-ASSIGNING
            </div>
          </div>
        </div>,
        {
          closeButton: false,
          close: this.props.closeModal,
        }
      );
    }
  }

  saveToDistrict(startDate, endDate) {
    this.props.closeModal();
    this.setState({
      loading: true,
    });

    const { district, schools } = getUserData();
    const districtId = district.id;
    const licenseData = this.state.licenseData;

    updateAssessmentConfigForDistrict(districtId, schools, {
      windowDisabledByGrade: this.state.windowDisabledByGrade,
    }).then(() => {
      updateDistrictScreeningWindow(districtId, startDate, endDate, licenseData)
      .then((res) => this.resetScreen(res));
    });
    
  }

  async saveToSchool(startDate, endDate, schoolId) {
    this.props.closeModal();
    this.setState({
      loading: true,
    });

    const { district } = getUserData();
    const districtId = district.id;
    const licenseData = this.state.licenseData;
    // Disabled for now - do not allow school level to set yet.
    // await updateAssessmentConfigForSchool(districtId, schoolId, {
    //   windowDisabledByGrade: this.state.windowDisabledByGrade,
    // })

    updateSchoolScreeningWindow(schoolId, startDate, endDate, licenseData)
      .then((res) => this.resetScreen(res));
  }

  resetScreen(results = [], saveToDistrict = false) {
    const numberOfConfigSaved = saveToDistrict ? results.numberOfChanges : 1;
    this.showToast(saveToDistrict, numberOfConfigSaved);

    this.fetchConfiguration();
  }

  clearWindow() {
    if(this.state.isDistrictAssignmentAssigned && this.state.selectedEntity == 'school') {
      return;
    }

    this.setState({
      loading: true,
      windowDisabledByGrade: defaultWindowDisabledByGrade,
    });
    if(this.state.selectedEntity === 'school') {
      this.clearSchoolWindow();
    } else {
      this.clearDistrictWindow();
    }
  }

  clearDistrictWindow() {

    const { district, schools } = getUserData();
    const districtId = district.id;

    updateAssessmentConfigForDistrict(districtId, schools, {
      windowDisabledByGrade: defaultWindowDisabledByGrade,
    })

    unassignAllDistrictAssignments(districtId)
    .then(this.fetchConfiguration)
    .catch((error) => {
      console.error("Error unassigning district assignments", error);
      this.setState({
        loading: false,
      });
    });
  }

  async clearSchoolWindow() {
    const selectedSchool = this.props.selectedSchool || getUserData().schools[0]

    // Disabled for now - do not allow school level to clear because we don't allow school level to set yet.
    // const { district } = getUserData();
    // await updateAssessmentConfigForSchool(district.id, selectedSchool.id, {
    //   windowDisabledByGrade: defaultWindowDisabledByGrade,
    // })

    unassignSchoolAssignments(selectedSchool.id)
    .then(this.fetchConfiguration)
    .catch((error) => {
      console.error("Error unassigning school assignments", error);
      this.setState({
        loading: false,
      });
    });
  }

  showToast(saveToDistrict, numberOfConfigSaved = 1) {
    const { district, schools } = getUserData();
    const selectedSchool = this.props.selectedSchool || schools[0];
    const target = saveToDistrict
      ? (<React.Fragment>district <strong>{district.label}</strong> ({numberOfConfigSaved} schools).</React.Fragment>)
      : (<strong>{selectedSchool.label}</strong>);

    toast.custom(
      <div style={{ backgroundColor: 'white', padding: 20, fontSize: 18, border: '1px solid #ccc', borderRadius: 10 }}>
        <div className='toastTitle' style={{ fontWeight: 'bold' }}>
          <FaCheckCircle size={24} color="green" style={{ marginRight: 10 }} />
          Changes Saved!
        </div>
        <div className='toastBody'>You've updated benchmark assessments for {target} </div>
      </div>,
      {
        duration: 3000,
      }
    );
  }

  render() {
    const selectionProps = {
      pageTitle: "Screening Window",
      isAggregateReport: true,
      hasScoreScaling: false,
      isSchoolReport: true,
    };

    const saveButtonClasses = cx({
      "primaryTeacherButton": true,
      "inactive": !this.state.screeningWindowChanged,
    });

    const disableBenchmarkBtnClasses = cx({
      "primaryTeacherButton": true,
      "inactive": this.state.isDistrictAssignmentAssigned && this.state.selectedEntity == 'school',
    });

    const { userType, district } = getUserData();
    const isDistrictAdmin = userType == "DISTRICT_ADMIN";

    return (
      <div className="reports-root-container">
        <Toaster />
        <div className="reports-page-wrap">
          <div className="reports-page">
          {isDistrictAdmin &&
            <TeacherSelections
              enableSchoolDistrictToggle={true}
              onEntityChange={this.onEntityChange}
              teacherSelectionTypes={selectionProps}
              selectedSchool={this.props.selectedSchool}
              history={this.props.history}
              isAdminReport={true}
            />
          }
            <div className="reports-container benchmark-assessment">
              <div className='instructions'>
              {(this.state.loading || (this.props.status && this.props.status.type === 'PENDING'))
                ? <Loading />
                : <p>SET A SCREENING WINDOW FOR {(this.state.selectedEntity === 'school' && this.props.selectedSchool)
                    ? this.props.selectedSchool.label.toUpperCase()
                    : `${district.label.toUpperCase()} DISTRICT`}
                  </p>
              }
              </div>
              <div className="overviewContainer">
                <div className="instructions">
                  <p>Set a screening window for benchmark assessment by choosing a start and end date for your window.</p>
                  <p>Within the date range specified, students who haven’t yet completed a benchmark assessment in the current screening window will be automatically presented with one the next time they log in.</p>
                  <p>To administer subsequent benchmark assessments, update the date range.</p>
                {(this.state.loading || (this.props.status && this.props.status.type === 'PENDING'))
                ? <Loading />
                : !this.state.dateRangePickerVisible &&
                  <div className={`getStartedContainer ${this.state.isDistrictAssignmentAssigned && this.state.selectedEntity == 'school' ? 'warning' : ''}`}>
                    <div style={{ display: 'flex' }}>
                      <div style={{ marginRight: '20px' }}>{this.state.isDistrictAssignmentAssigned && this.state.selectedEntity == 'school' && <FaExclamationTriangle color="red" size={60} />}</div>
                      <div style={{ lineHeight: '24px' }}>{this.state.welcomeMessage}</div>
                    </div>
                    <DisableByGradeBanner disabledGrades={this.state.windowDisabledByGrade} hasWindowSet={this.state.hasScreeningWindowSchool || this.state.hasScreeningWindowDistrict} />
                    <div style={{ marginTop: '20px' }}>
                      <button className="primaryTeacherButton screening" onClick={this.setupWindow}>
                        {this.state.screeningWindow.endDate
                          ? (`${(this.state.isDistrictAssignmentAssigned && this.state.selectedEntity == 'district') || (!this.state.isDistrictAssignmentAssigned && this.state.selectedEntity == 'school') ? 'Update' : 'Override'} Screening Window`)
                          : 'Set a Screening Window'
                        }
                      </button>
                    </div>
                  </div>
                }
                </div>
                <div className="screeningWindowsContainer">
                  <table className="screeningWindowsTable">
                    <thead>
                      <tr className="table-header-row">
                        <th>Window</th>
                        <th>Start</th>
                        <th>End</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="table-body-row">
                        <td>BOY</td>
                        <td>Aug 1</td>
                        <td>Nov 30</td>
                      </tr>
                      <tr className="table-body-row">
                        <td>MOY</td>
                        <td>Dec 1</td>
                        <td>Mar 31</td>
                      </tr>
                      <tr className="table-body-row">
                        <td>EOY</td>
                        <td>Apr 1</td>
                        <td>Jul 31</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='table-wrapper-caption'>Fig 1: {GetBrandedAppName()} Assessment Calendar</div>
                </div>
              </div>
              <div className="dateRangeContainer">
                {this.state.dateRangePickerVisible &&
                  <div className="dateRangeForm">
                    <DateRangePicker dateRange={this.state.screeningWindow} onDateRangeChange={this.onDateRangeChange} />
                    <div className="dateRangeFormButtons">
                      <button className={saveButtonClasses} onClick={this.saveWindow}>Save benchmark assessment window</button>
                      <button className={disableBenchmarkBtnClasses} onClick={this.clearWindow}>Disable benchmark assessment window</button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    selectedSchool: get(state, 'reports.roster.ui.selections.school', null),
    status: get(state, 'reports.roster.status'),
  };
}

export default connect(mapStateToProps)(BenchmarkAssessment);
